import { storeOrUpdateAdmin } from '@/api/admin'
import { getRoles, getAdmins, getWorkers, getCorporations, getTeams, getKvData } from '@/api/open'
import Sortable from 'sortablejs'

export default {
    components: {},
    props: {
        showForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            labelCol: {span: 4},
            wrapperCol: {span: 18},
            roles: [],
            corporations: [],
            loading: false,
            rules: {
                username: [{required: true, message: '请输入账号', trigger: 'change'}],
                role_id: [{required: true, message: '请选择角色', trigger: 'change'}],
                name: [{required: true, message: '请输入姓名', trigger: 'change'}],
            },
            workers: [],
            teams: [],
            admins:[],
            emails:[],
            mediaCorporations: [],
            sortableInstance: null,
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        },
        mobilesString: {
            get() {
                // 如果是数组，转换为逗号分隔的字符串
                if (Array.isArray(this.model.mobiles)) {
                    return this.model.mobiles.join(',')
                }
                // 如果是字符串，直接返回
                if (typeof this.model.mobiles === 'string') {
                    return this.model.mobiles
                }
                // 其他情况返回空字符串
                return ''
            },
            set(value) {
                // 保存为字符串
                this.model.mobiles = value
            }
        },
        isAllMaterialsSelected() {
            if (!Array.isArray(this.model.material_ids) || !Array.isArray(this.admins) || this.admins.length === 0) {
                return false;
            }
            
            const allIds = this.admins.map(admin => admin.id);

            // 检查是否选择了所有ID
            return allIds.length > 0 && allIds.every(id => this.model.material_ids.includes(id));
        }
    },
    mounted() {
        if (!this.model.id) {
            this.rules.password = [{required: true, message: '请输入密码', trigger: 'change'}]
        }
        // 绑定主体必填：新增时必填；修改时仅当原本已绑定主体（超管账号本身无绑定，不做强制）
        const originCorporationIds = Array.isArray(this.model.corporation_ids) ? this.model.corporation_ids : []
        if (!this.model.id || originCorporationIds.length > 0) {
            this.rules.corporation_ids = [{required: true, type: 'array', min: 1, message: '请选择绑定主体', trigger: 'change'}]
        }
        getRoles().then(res => {
            this.roles = res.data.list
        })
        getWorkers().then(res => {
            this.workers = res.data.list
        })
        getTeams().then(res => {
            this.teams = res.data.list
        })
        getAdmins().then(res => {
            this.admins = res.data.list
        })
        getCorporations().then(res=>{
            this.corporations = res.data.list
            if (this.corporations.length > 0) {
                // 主体默认设置为最后一个
                this.model.corporation_id = this.corporations[this.corporations.length - 1].id
                this.getjuliangEmails()
                if (this.model.corporation_id) {
                    this.kvData(this.model.corporation_id)
                }
            }
        })
        this.$nextTick(() => {
            this.initDrag()
        })
    },
    watch: {
        'model.media_corporations': {
            handler() {
              this.initDrag();
            },
            deep: true,
          },
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            this.loading = true
            storeOrUpdateAdmin(this.model).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.model.id > 0 ? '修改成功' : '添加成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showForm', false)
        },
        getjuliangEmails(){
            getKvData({corporation_id:this.model.corporation_id, type:5, flag:"getName"}).then(res=>{ this.emails = res.data.list || {} })
        },
        kvData(corporation_id) {
            getKvData({type:100, corporation_id: corporation_id}).then(res => {
                this.mediaCorporations = res.data.list || []
            })
        },
        removeSelected(item) {
            const index = this.model.media_corporations.indexOf(item)
            if (index !== -1) {
                this.model.media_corporations.splice(index, 1)
            }
        },
        initDrag() {
            this.$nextTick(() => {
                const container = this.$refs.dragContainer;
                if (!container || !(container instanceof HTMLElement)) return;
            
                // 如果已存在 sortable 实例，先销毁
                if (this.sortableInstance) {
                this.sortableInstance.destroy();
                }
            
                this.sortableInstance = Sortable.create(container, {
                animation: 150,
                onEnd: (evt) => {
                    // 拖拽结束后，根据新顺序调整 this.model.media_corporations
                    const movedItem = this.model.media_corporations.splice(evt.oldIndex, 1)[0];
                    this.model.media_corporations.splice(evt.newIndex, 0, movedItem);
                }
                });
            });
        },
        handleMaterialChange(value) {
            // console.log('handleMaterialChange value:', value);
            // console.log('当前 material_ids:', this.model.material_ids);
            
            // 处理全选逻辑
            if (value.includes('all')) {
                // 获取所有素材账户的ID
                const allIds = this.admins.map(admin => admin.id);
                
                // 判断当前是否已经全选（排除'all'标记）
                const currentIds = this.model.material_ids || [];
                const hasAllIds = allIds.every(id => currentIds.includes(id));
                
                // console.log('hasAllIds:', hasAllIds);
                
                if (hasAllIds) {
                    // 如果已经全选，点击则清空所有
                    this.model.material_ids = [];
                } else {
                    // 否则选中所有素材账户
                    this.model.material_ids = [...allIds];
                }
            } else {
                // 其他操作，更新值（过滤掉'all'标记）
                const filteredValue = value.filter(item => item !== 'all');
                this.model.material_ids = filteredValue;
            }
            
            // console.log('修改后 material_ids:', this.model.material_ids);
        },
    }
}
